<template>
    <div class="basic-fallback" justify-center wrap>
        <img class="logo-image" src="../../../assets/mendelu-logo.png">
        <Loading v-if="!isConnected" class="loading" :size="25"/>
    </div>
</template>

<script>
import Loading from "../../../components/Loading";

export default {
    name: "BasicFallback",

    props: {
        isConnected: Boolean,
    },

    components: {
        Loading
    },
}
</script>

<style scoped>
    .basic-fallback {
        background: black;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .logo-image {
        width: 35vh;
        height: auto;
    }

    .loading {
        position: absolute;
        top: 10px;
        right: 45px;
    }
</style>
